exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container {\n  height: 97%;\n  overflow: hidden;\n  margin-bottom: 1em; }\n\n.chart-container {\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/summary/style.scss
// module id = 1453
// module chunks = 0